import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'sessionErrorDialog.title',
    defaultMessage: 'Invalid session',
    description: 'Title of the session error dialog',
  },
  description: {
    id: 'sessionErrorDialog.description',
    defaultMessage:
      'Your session has expired or an error occurred within your session. Please log in again to continue your session.',
    description: 'Description of the session error dialog',
  },
  supportDescription: {
    id: 'sessionErrorDialog.supportDescription',
    defaultMessage:
      'If you keep getting this message directly after logging in again. Please contact our Afosto support.',
    description: 'Support description of the session error dialog',
  },
  actions: {
    loginAgain: {
      id: 'sessionErrorDialog.actions.loginAgain',
      defaultMessage: 'Log in again',
      description: 'Label of the log in again action in the session error dialog',
    },
  },
};

export default defineMessages(translations);
